import React from 'react'
import { connect } from 'react-redux'
import style from './style'
import injectSheet from 'react-jss'
import { updateCalculatorAction } from 'actions/calculatorActions'
import { CAMERA_SELECTED_COLORS } from 'helpers/globals'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const ColorPicker = ({ showColorPicker, setColorValue, currentColor, classes }) =>
  <div className={classes.colorPicker} style={{ display: showColorPicker ? 'flex' : 'none' }}>
    {
      Object.keys(CAMERA_SELECTED_COLORS).map((colorKey, i) =>
        <div
          onClick={_ => setColorValue(colorKey)}
          className={classes.color}
          style={{ background: CAMERA_SELECTED_COLORS[colorKey] }}
          key={i + colorKey}
        >
          { currentColor === colorKey &&
            <FontAwesomeIcon icon='check' className={classes.checkIcon} />
          }
        </div>
      )
    }
  </div>

class CameraColorPicker extends React.Component {
  state = {
    showColorPicker: false
  }

  setColorValue(value) {
    const { updateCalculatorAction, currentCamera } = this.props
    updateCalculatorAction(value, 'color', currentCamera.id)
    this.setState({ showColorPicker: false })
  }

  render() {
    const { setColorValue, state: { showColorPicker }, props: { currentCamera, classes } } = this
    this.setColorValue = this.setColorValue.bind(this)

    return (
      <div className={classes.colorWrapper}>
        <div
          onClick={_ => this.setState({ showColorPicker: !showColorPicker })}
          className={classes.picker}
          title='Change Camera Color'
        >
          <FontAwesomeIcon icon='fill' className={classes.fillIcon} style={{ color: CAMERA_SELECTED_COLORS[currentCamera.color] }} />
        </div>
        <ColorPicker {...{ showColorPicker, setColorValue, currentColor: currentCamera.color, classes }} />
      </div>
    )
  }
}

export default connect(null, { updateCalculatorAction })(injectSheet(style)(CameraColorPicker))



// WEBPACK FOOTER //
// ./src/components/BottomBar/CameraConfig/CameraColorPicker/index.js